import React, { useEffect, useState } from 'react'
import Footer from './footer'
import Header from './header'
import HeaderContext from '../context/headerContext'
import { getBannerList, getNewCateList } from '../api/api'
import { useLocation } from 'react-router-dom'

const Layout = ({ white = false, children }) => {
  const [navList, setNavList] = useState([])
  const { pathname } = useLocation()

  useEffect(() => {
    getBannerList().then(re => {
      setNavList(re.data)
    })
  }, [])

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [pathname])

  return (
    <HeaderContext.Provider value={{ navList, setNavList }}>
      {/* 添加 layout 元素 */}
      <header>
        <Header />
      </header>
      <main className={`${white ? 'bg-white' : 'bg-[#f9f9f9]'} pb-0 lg:pb-20`}>{children}</main>
      <footer>
        <Footer />
      </footer>
    </HeaderContext.Provider>
  )
}

export default Layout
